import log from 'loglevel';

// 本番環境でのデバッグログは性能に影響するため警告レベルに制限
if (import.meta.env.MODE === 'development') {
  log.setLevel('debug');
} else {
  log.setLevel('warn');
}

class Logger {
  private formatMessage(message: string, context?: Record<string, unknown>): string {
    const contextStr = context ? ` ${JSON.stringify(context)}` : '';
    return `${message}${contextStr}`;
  }

  debug(message: string, context?: Record<string, unknown>) {
    log.debug(this.formatMessage(message, context));
  }

  info(message: string, context?: Record<string, unknown>) {
    log.info(this.formatMessage(message, context));
  }

  warn(message: string, context?: Record<string, unknown>) {
    log.warn(this.formatMessage(message, context));
  }

  error(message: string, error?: Error, context?: Record<string, unknown>) {
    const fullContext = { ...context, error: error?.message };
    log.error(this.formatMessage(message, fullContext));
    if (error && import.meta.env.MODE === 'development') {
      log.error(error);
    }
  }
}

export const logger = new Logger();
